const types = {

  GET_LIST_CPA:'cpaoffer/GET_LIST_CPA',
  GET_ITEM_CPA:'cpaoffer/GET_ITEM_CPA',
};

export default types;
